/**
 * Created by jiachenpan on 16/11/18.
 */

import store from '@/store'
import moment from 'moment'

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function guidGenerator() {
  
  var S4 = function() {
     return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  };
  return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}
/**
 * Check the Authority.
 * @param {String|Array} permissions 
 */
export function canAccess (permissions) {
  
  if(!permissions) {
    return true;
  }

  if(typeof permissions ==='string') {
    permissions = [permissions];
  }

  let has_access = false;
  permissions.map(function(permission) {
    
    if(store.getters.permissions.indexOf(permission) !== -1 || (store.getters.authProfile && store.getters.authProfile.role_id === 1) ) {
      has_access = true;
    }
  })

  return has_access;
}
export function getTimeOffset () {
  let user_timezone = (new Date).getTimezoneOffset();
  let sign = user_timezone <= 0 ? '+' : '-';  
  user_timezone = Math.abs(user_timezone);
  let modulus = user_timezone % 60;
  let absolute_number = parseInt(user_timezone/60);
  return sign + pad(absolute_number, 2) + (modulus ? ':' + pad(modulus, 2) : ':00' );
}

export function pad (value, size) {
  var s = value.toString();
  while (s.length < (size || 2)) {s = "0" + s;}
  return s;
}

export function ahpc(key) {
  const values = {
    full: 'Full',
    conditional: 'Conditional',
    temporary: 'Temporary/NA'
  }
  return values[key] ? values[key] : 'NA';
}

export function utcNow()  {
  let now = new Date();
  let nowUtc = new Date( now.getTime() + (now.getTimezoneOffset() * 60000));
  return moment(nowUtc).format('YYYYMMDDHHmmss')
}